import { VBtn } from 'vuetify/lib' 
import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import moment from 'moment'
const createdParams = () => ({
    team_id: null,
    company_id: null,
    start_at: null,
    end_at: null,
    invoice_entered: null
})
export default {
    data() {
        return {
            show: false,
            params: createdParams()
        }
    },
    computed: {
        min_date() {
            if (this.params.end_at) {
                return moment(this.params.end_at).subtract(1, 'year').format('YYYY-MM-DD')
            }
            return null
        },
        max_date() {
            if (this.params.start_at) {
                return moment(this.params.start_at).add(1, 'year').format('YYYY-MM-DD')
            }
            return null
        },
        fields() {
         //   console.log(' this.min_date', this.min_date)
            return [
                {
                    label: '起始时间',
                    type: 'date_picker_v1',
                    key:'start_at',
                    required: true,
                    cols: 6,
                    rules: [val => !!val || '必选'],
                    allowedDates: (val) => {
                        if (this.params.end_at && val > this.params.end_at) {
                         return false
                        }
                        if (this.params.end_at && 
                            this.min_date &&
                            val < this.min_date) {
                            return false
                           }
                        return true
                     },
                    // date_range_v1
                },
                {
                    label: '结束时间',
                    type: 'date_picker_v1',
                    key:'end_at',
                    required: true,
                    cols: 6,
                    rules: [val => !!val || '必选'],
                    allowedDates: (val) => {
                        if (this.params.start_at && val < this.params.start_at) {
                         return false
                        }
                        if (this.params.start_at && 
                            this.max_date &&
                            val > this.max_date) {
                            return false
                           }
                        return true
                     },
                    // date_range_v1
                },
                {
                    label: '团队',
                    type: 'team_select',
                    key: 'team_id',
                    // required: true,
                    clearable: true,
                    cols: 12,
                   // rules: [commonValidateRuleGo],
                    // change: (val) => {
                    //     const team_company_mapping_hash = this.team_company_mapping_hash
                       
                    //     if (!team_company_mapping_hash.companyTeamCorrespond(val, this.params.company_id)) {
                    //         const company = team_company_mapping_hash.companyTeamCorrespondGetCompant(val)
                    //         this.params.company_id = company && company.company_id
                    //     }
                    // }
                },
                {
                    label: '公司',
                    type: 'company_select',
                    key: 'company_id',
                    cols:12,
                    clearable: true,
                    // required: true,
                    // rules:[commonValidateRuleGo],
                },

                {
                    label: '校验状态',
                    key:'invoice_entered',
                    type:'select_field_v1',
                    // required: true,
                    clearable: true,
                    items: [
                        {
                            title: '已录入',
                            key: true,
                        },
                        {
                            title: '未录入',
                            key: false,
                        },
                    ],
                    cols: 12,
                  //  rules:[commonValidateRuleGo],
                  
                },
            ]
        }
    },
    render() {
       
        return <span>
            <VModal 
             v-model={this.show}
             dynamicHeight
             heightRate={0.6}
             title="导出"
           
             width={500}
             ref="modal"
             ok-text="导出"
             on={{
                 ok: () => {
                    if (this.$refs.form.validate()) {
                        let str = []
                        const not_except = ['', undefined, null]
                        Object.keys(this.params).forEach(key => {
                            if (not_except.includes(this.params[key])) {
                                return 
                            } 
                            str.push(`${key}=${this.params[key]}`)
                        })
                        str = str.join('&')
                        
                        window.open(`/api/expense_group/export_invoice_register?${str}`, '__blank')
                    }
                 },
             }}
            >
                <VForm
                    ref="form"
                    v-model={this.params}
                    fields={this.fields}
                />
            </VModal>
            <VBtn on={{
                click: () => {
                    this.show = true
                }
            }}>导出</VBtn>
        </span> 
    }
}
